/*******************************************************************************
 * Copyright (c) 2018. keni <$email>
 *
 * This file window.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * window.js can not be copied and/or distributed
 * without the express permission of keni
 ******************************************************************************/
import {TweenMax, TweenLite} from 'gsap'

// import {ScrollToPlugin} from '../../../../../../node_modules/gsap/ScrollToPlugin.js';
import "../../../../../../node_modules/gsap/ScrollToPlugin";
// import {scrollToTarget}


export default function windowDimensions(elementId) {
	//get height of the nav bar
	let elm = document.getElementById(elementId);
	if (!elm) {
		return null;
	}
	let rectangle = elm.getBoundingClientRect();

	return {
		h: elm.offsetHeight,
		w: elm.offsetWidth,
		position: {
			top: rectangle.top,
			bottom: rectangle.bottom,
			left: rectangle.left,
			right: rectangle.right,

		}
	};
}
function offsetElm(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
export function scrollToTarget(elementId, parentElement) {
	if (!(typeof parentElement !== 'undefined' && parentElement !== null)) {
		parentElement = 'html, body';
	}
	let offset = 100, main_nav = document.getElementById('main-nav');

	if (main_nav !== null) {
		offset = main_nav.clientHeight;
	}
	offset = offset + 20;
	if($('#'+elementId).length){
		$(parentElement)
			.animate({
				scrollTop: $(`#${elementId}`).offset().top - offset
			}, 2000);
	}
}



// WEBPACK FOOTER //
// ./app/Shared/Resources/Assets/js/helpers/window.tools.js